export const formatTimestampDate = (timestamp: string): string => {
  const timestampDate = new Date(timestamp);

  if (timestamp && timestamp !== '' && timestampDate instanceof Date && !isNaN(timestampDate.getTime())) {
    const day = timestampDate.getDate().toString().padStart(2, '0');
    const month = timestampDate.toLocaleString('default', { month: 'short' });

    const hours = timestampDate.getHours().toString().padStart(2, '0');
    const minutes = timestampDate.getMinutes().toString().padStart(2, '0');

    return `${day}. ${month} - ${hours}:${minutes}`;
  }

  return '';
};
